import { render, staticRenderFns } from "./previewBpmn.vue?vue&type=template&id=205a4042&scoped=true&"
import script from "./previewBpmn.vue?vue&type=script&lang=js&"
export * from "./previewBpmn.vue?vue&type=script&lang=js&"
import style0 from "./previewBpmn.vue?vue&type=style&index=0&id=205a4042&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205a4042",
  null
  
)

export default component.exports